import React from "react";

/**
 * I18nCoverageBar — QUESTIONNAIRE-2.0-A-S1.
 *
 * Tiny stacked bar showing translation coverage for a single language:
 * reviewed (green) · pending_review (amber) · draft (slate) · missing (transparent).
 * Read-only purely visual; click handler optional.
 */
const I18nCoverageBar = ({ lang, onClick, compact = false }) => {
  const total = lang?.total_keys || 0;
  const rv = lang?.reviewed_count || 0;
  const pr = lang?.pending_review_count || 0;
  const dr = lang?.draft_count || 0;
  const nu = lang?.needs_update_count || 0;
  const ms = lang?.missing_status_count || 0;
  const pct = (n) => (total > 0 ? (n / total) * 100 : 0);

  const testId = `i18n-coverage-bar-${lang?.language_code || "unknown"}`;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`group relative flex w-full items-center gap-1 ${compact ? "h-1.5" : "h-2"} overflow-hidden rounded bg-slate-100 outline-none hover:ring-1 hover:ring-sky-400 focus-visible:ring-2 focus-visible:ring-sky-500`}
      title={`${lang?.language_name_en || lang?.language_code} · ${lang?.completion_percentage ?? 0}% reviewed`}
    >
      <span className="h-full bg-emerald-500" style={{ width: `${pct(rv)}%` }} />
      <span className="h-full bg-amber-400" style={{ width: `${pct(pr)}%` }} />
      <span className="h-full bg-rose-400" style={{ width: `${pct(nu)}%` }} />
      <span className="h-full bg-slate-400" style={{ width: `${pct(dr)}%` }} />
      <span className="h-full bg-transparent" style={{ width: `${pct(ms)}%` }} />
    </button>
  );
};

export default I18nCoverageBar;
